import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";

function AboutFive() {
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <>
      <VisibilitySensor onChange={onChange} partialVisibility>
        <div className="section-about-four">
          <div className={`section-four-title ${isVisible ? "visible" : ""}`}>
            <h1>Nossas políticas</h1>
          </div>
          <div className="section-four-content">
            <div className="item">
              <h2 className={`itemHOne ${isVisible ? "visible" : ""}`}>
                Política de Segurança
              </h2>
              <p className={`itemPOne ${isVisible ? "visible" : ""}`}>
                Garantimos que nossa empresa esteja em conformidade com todas as
                leis e regulamentações relevantes relacionadas à segurança
                privada, incluindo licenciamento, treinamento de funcionários e
                normas éticas de conduta. Esta política de segurança é uma parte
                essencial de nossa cultura organizacional e é incorporada em
                todas as nossas operações diárias. Todos os funcionários são
                responsáveis por seguir esta política e contribuir para um
                ambiente seguro e protegido.
              </p>
            </div>
            <div className="item ">
              <h2 className={`itemHTwo ${isVisible ? "visible" : ""}`}>
                Política de Qualidade
              </h2>
              <p className={`itemPTwo ${isVisible ? "visible" : ""}`}>
                Na Portovig, nosso compromisso é cuidar dos nossos clientes. Trabalhamos para garantir a excelência 
                e a qualidade em nossos serviços, sempre buscando a satisfação dos nossos clientes.
              </p>
            </div>
          </div>
        </div>
      </VisibilitySensor>
    </>
  );
}

export default AboutFive;
